import Footer from "../common/Footer";
import Header from "../common/Header";
import Icon1 from "../../Images/event-1(e&c).png";
import Icon2 from "../../Images/event-2(e&c).png";
import Icon3 from "../../Images/event-3(e&c).png";
import Icon4 from "../../Images/event-4(e&c).png";
import HappyClients from "./OurHappyClientsSection";
import CTA from "./CTASection";

const EventsAndConference = () => {
  return (
    <div className="flex flex-col bg-gradient-to-b from-[#5b5853] to-[#1a1a1a]">
      <Header />
      <div className="inset-0 bg-black/40">
        <main className="flex-grow py-20 px-4 text-center pt-[7rem] text-white z-10">
          <h1 className="text-4xl font-bold mb-6 mt-10">Event Services</h1>
          <p className="max-w-2xl mx-auto text-base md:text-lg text-white/90 mb-12">
            Semars Holding Company specializes in organizing high-profile
            events, business forums, and conferences in Saudi Arabia. From
            corporate meetings to exhibitions, we ensure that your event is
            planned and executed to the highest standards.
          </p>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-10 max-w-5xl mx-auto">
            <div
              className="flex flex-col items-center p-6 rounded-xl backdrop-blur-sm transition transform hover:scale-105 hover:bg-white/10 duration-300 ease-in-out"
              data-aos="fade-up"
            >
              <img
                src={Icon1}
                alt="Event & Logistics"
                className="w-[105px] h-auto mb-3"
              />
              <h3 className="text-xl font-semibold">Event & Logistics</h3>
            </div>

            <div
              className="flex flex-col items-center p-6 rounded-xl backdrop-blur-sm transition transform hover:scale-105 hover:bg-white/10 duration-300 ease-in-out"
              data-aos="fade-up"
            >
              <img
                src={Icon2}
                alt="Marketing & Promotion"
                className="w-[105px] h-auto mb-3"
              />
              <h3 className="text-xl font-semibold">Marketing & Promotion</h3>
            </div>

            <div
              className="flex flex-col items-center p-6 rounded-xl backdrop-blur-sm transition transform hover:scale-105 hover:bg-white/10 duration-300 ease-in-out"
              data-aos="fade-up"
            >
              <img
                src={Icon3}
                alt="Venue Selection & Setup"
                className="w-[105px] h-auto mb-3"
              />
              <h3 className="text-xl font-semibold">Venue Selection & Setup</h3>
            </div>

            <div
              className="flex flex-col items-center p-6 rounded-xl backdrop-blur-sm transition transform hover:scale-105 hover:bg-white/10 duration-300 ease-in-out"
              data-aos="fade-up"
            >
              <img
                src={Icon4}
                alt="Onsite Event Management"
                className="w-[105px] h-auto mb-3"
              />
              <h3 className="text-xl font-semibold">Onsite Event Management</h3>
            </div>
          </div>
        </main>
      </div>
      <HappyClients />
      <CTA />
      <Footer />
    </div>
  );
};

export default EventsAndConference;
